import { useTranslation } from 'react-i18next';
import { FooterWrapper, Container, Brand, Logo, BrandName, Copyright } from './Footer.styled';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <FooterWrapper>
      <Container>
        <Brand>
          <Logo src="/logo_32_32.png" alt="Scribia" />
          <BrandName>Scribia</BrandName>
        </Brand>
        <Copyright>{t('footer.copyright')}</Copyright>
      </Container>
    </FooterWrapper>
  );
}
